// extracted by mini-css-extract-plugin
export default {"textarea":"Textarea_textarea__u0c5l","label":"Textarea_label__D9BnJ"};